import { render, staticRenderFns } from "./ClientEditModal.vue?vue&type=template&id=3c34e379&scoped=true"
import script from "./ClientEditModal.vue?vue&type=script&lang=js"
export * from "./ClientEditModal.vue?vue&type=script&lang=js"
import style0 from "./ClientEditModal.vue?vue&type=style&index=0&id=3c34e379&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c34e379",
  null
  
)

export default component.exports